import React, { useEffect, useState } from 'react';
import { currentLocalTimeMinutes } from '@/utils/scheduleScroll';

export interface ScheduleCurrentTimeIndicatorProps {
  earliestTime: number;
  latestTime: number;
  className?: string;
  showLine?: boolean;
  showDot?: boolean;
}

export function ScheduleCurrentTimeIndicator({
  earliestTime,
  latestTime,
  className = '',
  showLine = true,
  showDot = false,
}: ScheduleCurrentTimeIndicatorProps) {
  const [nowMinutes, setNowMinutes] = useState(() => currentLocalTimeMinutes());

  useEffect(() => {
    const id = window.setInterval(() => {
      setNowMinutes(currentLocalTimeMinutes());
    }, 60_000);
    return () => window.clearInterval(id);
  }, []);

  const totalRange = latestTime - earliestTime;
  if (totalRange <= 0) return null;
  if (nowMinutes < earliestTime || nowMinutes > latestTime) return null;

  const topPercent = ((nowMinutes - earliestTime) / totalRange) * 100;

  return (
    <div
      className={`pointer-events-none absolute inset-x-0 z-30 ${className}`}
      style={{ top: `${topPercent}%` }}
      aria-hidden
    >
      {showDot ? (
        <span className="absolute -left-0.5 top-0 h-2 w-2 -translate-y-1/2 rounded-full bg-red-400/70 dark:bg-red-500/50" />
      ) : null}
      {showLine ? (
        <div className="border-t border-red-400/50 dark:border-red-500/40" />
      ) : null}
    </div>
  );
}
